(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('counter-stats')) {
    class CounterStats extends HTMLElement {
      connectedCallback() {
        this.numbers = this.querySelectorAll('[data-value]');
        if (!this.numbers.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.numbers.forEach((el) => {
            el.textContent = el.dataset.value;
          });
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.animateAll();
              this.observer.disconnect();
            });
          },
          { threshold: 0.35 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      animateAll() {
        this.numbers.forEach((el) => this.animate(el));
      }

      parse(value) {
        const raw = String(value).trim();
        const decimalMatch = raw.match(/\.(\d+)\s*$/);
        const decimals = decimalMatch ? decimalMatch[1].length : 0;
        const numeric = parseFloat(raw.replace(/,/g, ''));
        const useComma = raw.indexOf(',') !== -1;

        return {
          numeric: Number.isFinite(numeric) ? numeric : 0,
          decimals: decimals,
          useComma: useComma
        };
      }

      format(n, decimals, useComma) {
        const fixed = n.toFixed(decimals);
        if (!useComma) return fixed;

        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      }

      animate(el) {
        const parsed = this.parse(el.dataset.value);
        const duration = 1600;
        const start = performance.now();

        const tick = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = this.format(parsed.numeric * eased, parsed.decimals, parsed.useComma);
          if (t < 1) {
            requestAnimationFrame(tick);
          } else {
            el.textContent = el.dataset.value;
          }
        };

        requestAnimationFrame(tick);
      }
    }

    customElements.define('counter-stats', CounterStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-trigger"] && !Shopify.designMode) return;
  try {
    
  if (!window.__popupTriggerEditorBound) {
    window.__popupTriggerEditorBound = true;

    document.addEventListener('shopify:section:select', (evt) => {
      const modal = evt.target.querySelector('modal-dialog.popup-trigger-modal');
      if (modal && typeof modal.open === 'function') modal.open();
    });

    document.addEventListener('shopify:section:deselect', (evt) => {
      const modal = evt.target.querySelector('modal-dialog.popup-trigger-modal');
      if (modal && typeof modal.close === 'function') modal.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
